import React from 'react'
import { COLORES } from '../../../config/colores'

function UltimoPesadoInfo ({ ultimoPesado }) {
  return (
    <>
      <p
        style={{
          margin: '0 2%',
          padding: 0,
          textAlign: 'left',
          color: COLORES.grey.dark,
          fontWeight: 'bold'
        }}
      >
        Último pesado
      </p>
      <div className='ultimo-pesado-bruto'>
        <h6 style={{ margin: 0 }}>Cereal: <b>{ultimoPesado.claveCereal}</b> - Peso bruto: <b>{ultimoPesado.pesoBruto}</b></h6>
      </div>
    </>
  )
}

export default UltimoPesadoInfo
